import { EJNotificationEvent } from '@cims-online/shared'
import CIMSNotifications from 'components/CIMSNotifications'
import { useEdit } from './hooks/useEdit'
import RecipientsSelectProvider from 'components/CIMSSelect/common/RecipientsSelect/RecipientsSelectContext'
import EJNotificationsProvider, {
  useEJNotificationsContext,
} from './EJNotificationsContext'
import ViewEJNotifications from './components/ViewEJNotifications'

const Notifications: React.VFC = () => {
  const { loading, refetch } = useEJNotificationsContext()
  return (
    <CIMSNotifications
      events={EJNotificationEvent.values}
      edit={useEdit()}
      onReload={refetch}
      view={<ViewEJNotifications />}
      loading={loading}
    />
  )
}

const EJNotifications: React.VFC = () => {
  return (
    <RecipientsSelectProvider>
      <EJNotificationsProvider>
        <Notifications />
      </EJNotificationsProvider>
    </RecipientsSelectProvider>
  )
}

export default EJNotifications
